import { render, staticRenderFns } from "./RoomsAddUpdate.vue?vue&type=template&id=8b18c434&"
import script from "./RoomsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./RoomsAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RoomsAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports